import { ThreePointsStateType } from './types';

import { ThreePointsActionType } from 'enums';
import { ThreePointsActionReturnType } from 'state/actions';

const initState: ThreePointsStateType = {
  threePoints: [],
};

export const threePointsReducer = (
  // eslint-disable-next-line default-param-last
  state: ThreePointsStateType = initState,
  action: ThreePointsActionReturnType,
): ThreePointsStateType => {
  switch (action.type) {
    case ThreePointsActionType.SET_THREE_POINTS:
      return { ...state, threePoints: action.threePoints };
    default:
      return state;
  }
};
